export default __webpack_public_path__ + "static/media/championspirit.cff960f6.png";